import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import SupplierLedgerTab from './payables/SupplierLedgerTab';
import PayableInvoicesTab from './payables/PayableInvoicesTab';
import PayablePaymentsTab from './payables/PayablePaymentsTab';
import PayableBatchesTab from './payables/PayableBatchesTab';

// Day-to-day AP tabs. No Reports menu here (unlike Student Receivables) -
// config/ledger.php's 'ap' section whitelists only invoices/payments/
// payment-batches/supplier-ledger accounts, no ap-ar-reports/* prefix, so
// there's no aging report reachable through this gateway section.
const TABS = [
  { value: 'supplierLedger', label: 'Supplier Ledger', Component: SupplierLedgerTab },
  { value: 'invoices', label: 'Bills', Component: PayableInvoicesTab },
  { value: 'payments', label: 'Payments', Component: PayablePaymentsTab },
  { value: 'batches', label: 'Payment Batches', Component: PayableBatchesTab },
];

// Accounts Payable: the per-supplier AP subledger (config/ledger.php
// section 'ap') - bills, payments and payment batches. The mirror image of
// Student Receivables, for money owed to suppliers rather than owed by
// students; no school-side legacy system feeds this one (unlike AR's
// fee-collection bridge), so there's no sync panel here.
const AccountsPayable = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('supplierLedger');

  if (!can(RESOURCES.LEDGER.AP, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Accounts Payable.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Accounts Payable"
        subtitle="Per-supplier AP balances, bills and payments"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs
            value={tab}
            onChange={(_, v) => v && setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default AccountsPayable;
